import * as actionTypes from  '../actions/actionTypes';
import updateState from '../../utility'

const orderState ={
  orders: [],
  loading: false,
  purchased: false,
  deleted: false
}

const reducers= (state = orderState, action) => {
  switch (action.type) {
    
    case actionTypes.ORDER_START:
      return updateState(state,{ loading: true })

    case actionTypes.ORDER_SUCCESS:
      return updateState(state,{ loading: false })

    case actionTypes.ORDER_FAILURE:
      return updateState(state,{ loading: false })

    case actionTypes.ORDER_PURCHASED_SUCCESSFULLY:
      return updateState(state,{ purchased: true })

    case actionTypes.FETCH_ORDER_SUCCESS:
      return updateState(state, {orders: action.orders,loading: false})

    case actionTypes.FETCH_ORDER_FAIL:
      return updateState(state,{error: action.errors, loading: false})


    case actionTypes.FETCH_ORDER_START:
       return updateState(state,{ loading: true })

    case actionTypes.DELETE_ORDER:
      return updateState(state,{
        orders: state.orders.filter(order => order.id !== action.id),
        deleted: true
      })

    default:
      return state;
  }
}

export default reducers;



// WEBPACK FOOTER //
// ./src/store/reducer/order.js